import { Pipe, PipeTransform } from "@angular/core";

export enum TurthyType {
    DOT = "dot",
    BLANK = "blank",
    NA = "na"
}

@Pipe({
    name: "truthyValue",
    pure: true
})
export class TruthyPipe implements PipeTransform {
    transform(value: any, arg: string = 'dot') {
        if(value) {
            return value;
        } else {
            return arg && arg == TurthyType.BLANK ? '' : arg && arg == TurthyType.NA ? 'N/A' : arg && arg == TurthyType.DOT ? '---' : '---'
        }
    }
}